export default __webpack_public_path__ + "static/media/arrow-left.b4dd1334.svg";